import Class from '@/Class';
import type ViewExtensionFactory from '@/Factories/ViewExtensionFactory';

export default class ViewExtensionFactoryTuple extends Class {

    public control: JQuery<HTMLElement>;
    public factory: ViewExtensionFactory;

    constructor(factory: ViewExtensionFactory) {
        super();

        this.control = factory.getControl();
        this.factory = factory;
        this.isDisposable = true;
    }
}